export default "__VITE_ASSET__179e295e__"